import { map, pipe } from "rxjs";
import { UserProperty } from "src/app/core/models/user/user-property.model";
import { UserPropertiesContainerDto } from "src/app/infrastructure/lobby-proxy/DTOs/user.dto";

enum PropertyType {
    String = 'String',
    Date = 'Date',
    Boolean = 'Boolean',
    Number = 'Number'
}

export const mapUserPropertiesContainerDtoToUserProperty = pipe(
    map((source: UserPropertiesContainerDto) =>
        userPropertiesContainerDtoToUserProperty(source)
    )
)

export function userPropertiesContainerDtoToUserProperty(source: UserPropertiesContainerDto) {
    return source.properties.map(p => {

        let value: string | boolean | number | Date;

        switch (PropertyType[p.type as keyof typeof PropertyType]) {
            case PropertyType.Boolean: value = Boolean(p.value); break
            case PropertyType.Date: value = new Date(p.value); break
            case PropertyType.Number: value = Number(p.value); break
            default: value = p.value; break
        }

        return {
            name: p.name,
            value: value,
            isDefault: p.isDefault
        } as UserProperty

    })
}